export default "__VITE_ASSET__DsTdPt1C__"